import React, { useEffect } from "react";
import GoogleMapReact from "google-map-react";
function GoogleMap(props) {
  const defaultProps = {
    center: {
      lat: props.latVal,
      lng: props.lonVal,
    },
    zoom: 18,
  };

  const mystyle = {
    width: "auto",
    height: "600px",
  };

  const testStyle = { height: "100vh", width: "100%" };
  const AnyReactComponent = ({ text }) => <div className="map-marker">{text}</div>;

  return (
    <div style={mystyle}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyDnqumC1UwnQS5txLoAORNMBgnmiBMISkg" }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        language="cs"
        region="cs"
      >
        <AnyReactComponent lat={props.latVal} lng={props.lonVal} text="Naše ordinace" />
      </GoogleMapReact>
    </div>
  );
}

export default GoogleMap;
